import { render } from "./Demo3.vue?vue&type=template&id=2523812c&scoped=true&ts=true"
import script from "./Demo3.vue?vue&type=script&lang=ts"
export * from "./Demo3.vue?vue&type=script&lang=ts"

import "./Demo3.vue?vue&type=style&index=0&id=2523812c&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2523812c"]])

export default __exports__